import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SidebarEvaluacionDesempenio from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  deleteFactorName,
  editFactorName,
  getFactorName,
  saveFactorName,
} from "../../../redux/evaluacion_desempenio/FactorName/actions";

const FactorName = () => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    nombre: Yup.string().required("**Campo requerido"),
    descripcion: Yup.string().required("**Campo requerido"),
  });

  const { loading, saveLoading, factorName, factorNameError, formError } =
    useSelector((store) => store.factorName);
  const pages = Math.ceil(factorName ? factorName.count / limit : 0);

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
      Filter: "",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
      Filter: "",
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const _getFactorName = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getFactorName({
        offset: offs,
        limit: lim,
        tipo_busqueda: "nombre",
        filter: filt,
      })
    );

  useEffect(() => {
    _getFactorName();
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactorName(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    if (!edit) {
      dispatch(saveFactorName(req, setShowModal));
    } else {
      dispatch(editFactorName(req, editItem.id, index, setShowModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactorName(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteFactorName(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarEvaluacionDesempenio show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Nombre de factor
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            factorName &&
            factorName.count > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={factorName.data} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={factorName.count}
                  pages={pages}
                  pagFunc={_getFactorName}
                />
              </>
            )
          )}
          {!loading &&
            factorName &&
            factorName.count === 0 &&
            factorNameError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!factorNameError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {factorNameError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            descripcion: edit ? editItem.descripcion : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar nombre de factor" : "Crear nombre de factor"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Nombre
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    isInvalid={touched.nombre && errors.nombre}
                    isValid={touched.nombre && !errors.nombre}
                    onBlur={handleBlur("nombre")}
                    onChange={handleChange}
                    value={values.nombre}
                    className="rounded-pill"
                    type="text"
                    placeholder="Tipo de evaluación"
                  ></Form.Control>
                  {touched.nombre && errors.nombre && (
                    <div>
                      <small className="text-danger">{errors.nombre}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descripción
                  </Form.Label>
                  <Form.Control
                    id="descripcion"
                    name="descripcion"
                    isInvalid={touched.descripcion && errors.descripcion}
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={handleChange}
                    value={values.descripcion}
                    className="rounded"
                    as="textarea"
                    placeholder="Descripción de tipo de evaluación"
                  ></Form.Control>
                  {touched.descripcion && errors.descripcion && (
                    <div>
                      <small className="text-danger">
                        {errors.descripcion}
                      </small>
                    </div>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default FactorName;
